export const UpgradeTrackName = 'upgrade' as const

export const PurchaseTrackName = 'purchase' as const

export const BeginCheckoutTrackName = 'begin_checkout' as const

export const SignUpTrackName = 'sign_up' as const

export const LoginTrackName = 'login' as const
